import { Routes } from '@angular/router';
import { PageKey } from '../../../../shared/services/page/models/page.key';

export const clientsRoute: Routes = [{
  path: 'clients',
  loadComponent: () => import('./clients.component').then(m => m.ClientsComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./list/list.component').then(m => m.ListClientsComponent),
      data: {
        title: 'Visualizar Clientes',
        key: PageKey.MANAGE,
        fullscreen: true
      },
    },
    {
      path: 'create',
      loadComponent: () => import('./create/create.component').then(m => m.CreateClientComponent),
      data: {
        title: 'Criar Cliente',
        key: PageKey.MANAGE
      },
    },
    {
      path: ':id/update',
      loadComponent: () => import('./create/create.component').then(m => m.CreateClientComponent),
      data: {
        title: 'Atualizar Cliente',
        key: PageKey.MANAGE
      },
    },
    {
      path: ':id',
      loadComponent: () => import('./details/details.component').then(m => m.ClientDetailsComponent),
      data: {
        title: 'Detalhes do Cliente',
        key: PageKey.MANAGE,
        fullscreen: true
      },
    },
    {
      path: ':id/history',
      loadComponent: () => import('./history/history.component').then(m => m.ClientHistoryComponent),
      data: {
        title: 'Histórico do Cliente',
        key: PageKey.MANAGE,
        fullscreen: true
      },
    },
  ]
}];